import type { ProductInfo } from "@artis/sdk";
import type { SeriesStore, SettlementsPayload, SummaryPayload } from "@artis/sdk/worker";

import delta1 from "./mock-data/settlements-delta-1-changes.json";
import delta2 from "./mock-data/settlements-delta-2-quiet.json";
import snapshot from "./mock-data/settlements-snapshot.json";
import summary from "./mock-data/summary-single-product.json";
import spreadSub from "./mock-data/summary-spread-sub.json";

const SNAPSHOT = snapshot as SettlementsPayload;
const DELTAS = [delta1, delta2] as SettlementsPayload[];
const SUMMARY = summary as unknown as SummaryPayload;
const SPREAD_SUB = spreadSub as unknown as SummaryPayload;

/** The snapshot's products as catalog entries, so the main thread can publish them with `kind: "series"`. */
export const PRA_MOCK_PRODUCTS: readonly ProductInfo[] = SNAPSHOT.data.map((p) => ({
  id: p.product_id,
  kind: "series",
  name: p.name,
  package: p.source,
  defaultField: "value",
  fields: ["value"],
}));

/**
 * Stand-in for the PRA API: the snapshot and the summaries now, then one delta per `delayMs`.
 * Every pair of products gets the one subtract spread fixture; there is no divide fixture.
 * Returns a stop function.
 */
export const startPraMock = (store: SeriesStore, delayMs = 5_000): (() => void) => {
  store.applySettlements(SNAPSHOT);
  for (const p of SNAPSHOT.data) {
    store.applySummary(p.product_id, SUMMARY);
    for (const q of SNAPSHOT.data) {
      if (q !== p) store.applySummary(p.product_id, SPREAD_SUB, { op: "sub", id: q.product_id });
    }
  }
  const timers = DELTAS.map((delta, i) => setTimeout(() => store.applySettlements(delta), delayMs * (i + 1)));
  return () => {
    for (const t of timers) clearTimeout(t);
  };
};
